module.exports = __webpack_public_path__ + "static/5-ef3d8c0557859089aa8f59c0785320b9.jpeg";